export default __webpack_public_path__ + "static/media/clock.10227702.svg";